import Certification from "@/views/reporting/Certification.vue";
import Review from "@/views/reporting/Review.vue";
import CCDD from "@/ts/modules/reporting.ccdd";
import LHW from "@/ts/modules/reporting.lhw";
import NRH from "@/ts/modules/reporting.nrh";
import RA from "@/ts/modules/reporting.ra";
import RH from "@/ts/modules/reporting.rh";
import XFR from "@/ts/modules/reporting.xfr";

export default {
    Certification,
    Review,
    CCDD,
    LHW,
    NRH,
    RA,
    RH,
    XFR
}

